module.exports = __webpack_public_path__ + "img/xbit-login3.77b72d46.png";